import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=035b150e&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035b150e')) {
      api.createRecord('035b150e', component.options)
    } else {
      api.reload('035b150e', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=035b150e&", function () {
      api.rerender('035b150e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29EgEWqTIn6Oz/JS/comp/stardisplay.vue"
export default component.exports